<template>
  <div>
    <div class="fb fb-col fb-cross-center height-full">
      <p class="font-40 text-bold mt-80">请输入家长ID</p>
      <p class="font-34 c-171A1D-40 text-center mt-8"
        >输入链接里您孩子对应的家长ID<br />用以确定绑定关系</p
      >
      <input
        class="w-342 h-56 p-0-16 font-34 bd-radio-8 mt-40"
        ref="input"
        type="text"
        v-model="shortCode"
        @focus="handleFocus"
        placeholder="请输入"
      />
    </div>
    <div class="footer fb fb-cross-center">
      <md-button @click="searchInfo">确认</md-button>
    </div>
    <md-dialog class="bind-dialog" v-model="showDialog">
      <div slot="title" class="text-bold">请确认学生与家长信息是否正确</div>
      <div slot="content">
        <div class="c-171A1D wrap">
          <p class="text-bold mb-8">学生信息</p>
          <div
            class="w-p-80 mb-4 fb fb-main-between fb-cross-center"
            v-for="item in datas"
            :key="item.studentName"
          >
            <p>{{ item.studentName }}</p>
            <p>{{ item.classShortName }}</p>
          </div>
        </div>
        <div class="c-171A1D wrap mt-16">
          <p class="text-bold mb-8">家长信息</p>
          <div class="w-p-80 mb-4 fb fb-main-between fb-cross-center">
            <p>{{ guardianName }}</p>
          </div>
        </div>
      </div>
      <div slot="buttons" class="fb fb-main-around fb-cross-ceenter mb-20">
        <md-button
          @click="cancel"
          class="h-46 w-150"
          type="submary"
          plain
          :block="false"
          >重新输入</md-button
        >
        <md-button @click="confirm" class="h-46 w-150" :block="false"
          >确认并绑定</md-button
        >
      </div>
    </md-dialog>
  </div>
</template>

<script>
import mixin from '@/mixin'
import API from '@/api'
import { mcToast } from '@/utils/mcSdkUtils'
import { setItem } from '@/utils/comUtils'
export default {
  name: 'pageWechatBind',
  components: {},
  mixins: [mixin],
  data() {
    return {
      shortCode: '',
      showDialog: false,
      datas: [],
      guardianName: ''
    }
  },
  methods: {
    // 输入id点击确认
    searchInfo() {
      if (!this.shortCode) {
        mcToast({
          msg: '请输入家长ID'
        })
        return
      }
      let showLoading = this.$Toast({
        type: 'loading',
        duration: 9000,
        content: '加载中···'
      })
      showLoading.show()
      API.getStudentRelation({
        shortCode: this.shortCode,
        openId: this.wxOpenId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return mcToast({ msg: res.message })
          }
          if (!(res.studentInfoList || []).length) {
            this.router.push({
              path: '/wechat/empty',
              query: {
                type: 'noInfo'
              }
            })
          } else {
            this.datas = res.studentInfoList
            this.guardianName = res.guardianName
            this.showDialog = true
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          showLoading.hide()
        })
    },
    // 重新输入
    cancel() {
      this.shortCode = ''
      this.showDialog = false
    },
    // 确认绑定
    confirm() {
      API.gurdianBind({
        shortCode: this.shortCode,
        openId: this.wxOpenId
      })
        .then(res => {
          if (res && res.result && res.result !== '0') {
            return mcToast({ msg: res.message })
          }
          mcToast({ msg: '绑定成功' })
          // 保存登录token
          this.$store.commit('setToken', res)
          setItem('isFromBind', 'true')
          this.$store.commit('changeCurrentRole', 1)
          setTimeout(() => {
            this.$router.push('/')
          }, 300)
        })
        .catch(err => {
          console.log(err)
        })
    },
    //
    handleFocus() {
      if (navigator.clipboard) {
        navigator.clipboard.readText().then(text => {
          this.shortCode = text
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  background: rgba(23, 26, 29, 0.04);
  border: 0.5px solid rgba(126, 134, 142, 0.24);
  border-radius: 8px;
  padding: 16px;
}
</style>
<style lang="scss">
.bind-dialog {
  .md-dialog {
    width: 342px;
    .md-dialog__content {
      max-height: 600px !important;
    }
    .md-dialog__button {
      border: 0 none;
    }
  }
}
</style>
